<template>
  <div>
    <detail :prop="counterpartyRole" :value="tx.counterparty" :copiable="true"/>
    <detail :prop="i18n.lbl_amount()" :value="`${i18n.c(swimBalance(tx.amount, tx.asset))} ${tx.asset}`"/>

    <detail :prop="i18n.lbl_sender_fee()" :value="`${i18n.c(swimBalance(+tx.fees.source, tx.asset))} ${tx.asset}`"/>
    <detail :prop="i18n.lbl_recipient_fee()" :value="`${i18n.c(swimBalance(tx.fees.destination, tx.asset, ))} ${tx.asset}`"/>
    <detail :prop="i18n.lbl_fee_from_source()" :value="tx.sourcePaysForDest ? i18n.lbl_yes() : i18n.lbl_no()"/>
    <!-- <detail :prop="i18n.lbl_sender_fee_asset()" :value="tx.sourceFeeAsset"/>
    <detail :prop="i18n.lbl_recipient_fee_asset()" :value="tx.destinationFeeAsset"/> -->
    <detail :prop="i18n.lbl_date()" :value="tx.date"/>
    <template v-if="isExchange">
      <detail :prop="i18n.lbl_subject()" :value="`${tx.subject}`"/>
    </template>
  </div>
</template>

<script>
  import DetailsMixin from './details.mixin'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import {CRYPTO_CURRENCYS} from '@utils/consts'

  export default {
    name: 'transfer-details',
    mixins: [DetailsMixin, CurrencyRound],
    computed: {
      counterpartyRole () {
        return this.tx.direction === 'out' ? this.i18n.lbl_receiver() : this.i18n.lbl_sender()
      },
      isExchange () {
        const regex = RegExp('^exchange:', 'i')
        return !regex.test(this.tx.subject)
      }
    },
    methods: {
      swimBalance (val, asset) {
        if (Object.values(CRYPTO_CURRENCYS).includes(asset)) {
          return this.roundCurrency2(val, asset)
        }
        return this.roundCurrency(val, asset)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .subject-detail {
    text-align: right;
    margin-top: 8px
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/history/index/components/Details.TransferV2.vue